import { BottomNavigation, Button, PageModal } from '@otp/ui';
import { RequestHistoryItem } from 'src/components/most/list/history/item/index';
import { useTranslation } from 'react-i18next';
import styles from './modal.module.css';
import { PartialMostRequestHistoryType } from 'src/components/most/list/history/types';

interface HistoryItemProps {
  item: PartialMostRequestHistoryType;
  onClose: () => void;
}

export const RequestHistoryModal = ({ item, onClose }: HistoryItemProps) => {
  const { t } = useTranslation();

  return (
    <PageModal
      title={t('most.history-details.request-details')}
      onClose={onClose}
      open
      classes={{
        paper: styles.contentWrapper,
      }}
    >
      <RequestHistoryItem item={item} />
      <BottomNavigation>
        <Button variant="outlined" onClick={onClose}>
          {t('common.close')}
        </Button>
      </BottomNavigation>
    </PageModal>
  );
};
